import { ProjectPhaseStatus } from "../../../../models";
import { Column, Row } from "../../../../widget";
import { DateSchemaFields } from "../DateSchemaFields";
import { EditDatesPanelBanner } from "../EditDatesPanelBanner";
import { DateSectionProps } from "../models";

export const DesignSection = ({
  dates,
  handleUpdateProjectDates,
  hasDateError,
  schema,
}: DateSectionProps): JSX.Element => {
  return (
    <>
      <Row spacingV="m">
        <Column span={12}>
          <p className="body01">Design</p>
        </Column>
      </Row>
      <Row spacingV="l">
        <Column span={12}>
          <p className="body1">
            Enter key dates to help structure your workflow and align with your broader roadmap. These can be either
            confirmed or estimated, and can be updated as the project develops.
          </p>
        </Column>
      </Row>
      <DateSchemaFields
        schemaProperties={schema?.design.properties}
        values={dates.design}
        keyPrefix="design"
        hasError={hasDateError}
        onChange={handleUpdateProjectDates}
      />
      <EditDatesPanelBanner phaseStatus={dates.design.status as ProjectPhaseStatus} phaseEndDate={dates.design.end} />
    </>
  );
};
